import { useDispatch } from "react-redux";
import { updateSourceSkuByProduct } from "../../slices/productsSlice";
import { arrayHasItems } from "../../helpers/common";
import { ConnectVariantButton } from "./ConnectVariantButton";

export const SourceSKU = ({
    product,
    access,
    isLoading,
    openModalCallback,
    updateCallback,
    removeCallback
}) => {
    const dispatch = useDispatch();
    const handleRemoveSourceSku = async (sourceSku) => {
        try {
            await dispatch(updateSourceSkuByProduct({
                productId: product?.id,
                sourceSku,
                requestToUpdate: removeCallback,
                type: 'remove'
            })).unwrap();
            await updateCallback?.();
        } catch (error) {
            console.error("Error removing source SKU:", error);
        }
    };
    return (
        <div className="relative" key={product?.sourceSkus?.length}>
            <div className='flex items-center gap-2'>
                {access === "edit" && (
                    <ConnectVariantButton
                        onClickCallback={() => openModalCallback?.()}
                        isLoading={isLoading}
                    />
                )}
                {arrayHasItems(product?.sourceSkus) && (
                    <section className="flex gap-1 flex-wrap">
                        {product.sourceSkus.map((sourceSku) => {
                            return (
                                <div className="flex items-center gap-2">
                                    <span className="text-sm text-gray-900">{sourceSku?.sku}</span>
                                    {access === "edit" ? (
                                        <button
                                            onClick={() => handleRemoveSourceSku(sourceSku?.id)}
                                            disabled={isLoading}
                                            className="inline-flex items-center p-1 text-xs font-medium rounded hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 disabled:bg-gray-50"
                                            aria-label="Remove source SKU"
                                        >
                                            <svg className="h-4 w-4 text-gray-500 hover:text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                                            </svg>
                                        </button>
                                    ) : "|"}
                                </div>
                            )
                        })}
                    </section>

                )}
            </div>
        </div>
    )
}